import type { ComputedRef } from 'vue'
import type { AppSelectOption } from '@brighterly/lib-core-types/ui/selects/interfaces'

import { useListsStore } from '@shared/model'

export const CUSTOMER_EMPTY_CELL = '---'

interface CustomerOptionsReturn {
  statusOptions: ComputedRef<AppSelectOption[]>
  stageOptions: ComputedRef<AppSelectOption[]>
}

const toOptions = (record: Record<string, string>): AppSelectOption[] =>
  Object.entries(record).map(([value, text]) => ({ value, text }))

export const useCustomerOptions = (): CustomerOptionsReturn => {
  const listsStore = useListsStore()

  const statusOptions = computed<AppSelectOption[]>(() => toOptions(listsStore.getLists?.customer?.status ?? {}))
  const stageOptions = computed<AppSelectOption[]>(() => toOptions(listsStore.getLists?.discipline?.stage ?? {}))

  return { statusOptions, stageOptions }
}
